import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel-o" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn",
  width: "140"
}
const _hoisted_6 = {
  filter: "disabled",
  filterType: "checkbox",
  sort: "disabled",
  width: "20"
}
const _hoisted_7 = {
  filter: "nomeCliente",
  sort: "nomeCliente",
  width: "170"
}
const _hoisted_8 = {
  filter: "subject",
  sort: "title"
}
const _hoisted_9 = {
  filter: "ticketNumber",
  sort: "ticketNumber",
  width: "160"
}
const _hoisted_10 = {
  filter: "gestitoDa",
  sort: "assignedToUser",
  width: "220"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { colspan: "99" }
const _hoisted_14 = {
  key: 0,
  class: "pallino"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onUpdate:modelValue", "onChange"]
const _hoisted_18 = { value: "" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-primary pull-right ml-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
        }, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Mostra solo ticket aperti",
            text: "Mostra solo ticket aperti"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_toggler, {
            modelValue: _ctx.filter.stillOpenOnly,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.stillOpenOnly) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Chiuso",
                text: "Chiuso"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Title",
                text: "Title"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ticket number",
                text: "Ticket number"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Gestito da",
                text: "Gestito da"
              })
            ]),
            _hoisted_11
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.bool(item.disabled)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, [
                  (!item.fromBackend)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_14))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.nomeCliente), 1)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.subject), 1),
              _createElementVNode("td", null, [
                (_ctx.canSeeDetail(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("a", {
                        href: '#/helpTicket/detail/' + item.identifier
                      }, _toDisplayString(item.ticketNumber), 9, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                (_ctx.$store.state.isAdmin())
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((item.assignedToUser) = $event),
                      onChange: ($event: any) => (_ctx.assign(item))
                    }, [
                      _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Nessuno", "Nessuno")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: user.identifier
                        }, _toDisplayString(user.name), 9, _hoisted_19))
                      }), 128))
                    ], 40, _hoisted_17)), [
                      [_vModelSelect, item.assignedToUser]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.findUser(item.assignedToUser)), 1))
              ]),
              _hoisted_21
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}